module.exports = __webpack_public_path__ + "static/action-3370a1c86e6cf984426167f334aba39d.png";